import {useCallback, useEffect} from 'react'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {Grid} from '@mui/material'
import {LoadingButton} from '@mui/lab'
import * as yup from 'yup'

import MUIModal from '../../common/MUIModal'
import {FormProvider, RHFFileField, RHFRadioGroup, RHFTextField} from '../../common/hook-form'
import {useCreatePackage} from './useCreatePackage'

const schema = yup.object().shape({
  box_name: yup.string().required('Package Name is required'),
  box_type: yup.string().required('Package Type is required'),
  height_cm: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .required('Height is required')
    .positive('Height must be positive'),
  breadth_cm: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .required('Breadth is required')
    .positive('Breadth must be positive'),
  length_cm: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value
    })
    .required('Length is required')
    .positive('Length must be positive'),
  image: yup.array().of(yup.mixed().required('Image is required')),
})

export function AddPackage({open, onClose, refetch, selectedPackage}) {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      height_cm: '',
      breadth_cm: '',
      length_cm: '',
      box_name: '',
      box_type: '',
      status: 'ACTIVE',
    },
  })

  const {handleSubmit, setValue} = methods

  const onSuccess = useCallback(() => {
    onClose?.()
    refetch?.()
  }, [onClose, refetch])

  const {createPackage, isCreating} = useCreatePackage({onSuccess, packageId: selectedPackage?.id})

  useEffect(() => {
    if (selectedPackage) {
      const boxNameArray = selectedPackage.box_name.split(' - ')
      const lastIndex = boxNameArray.length - 1
      setValue('box_name', boxNameArray.slice(0, lastIndex).join(' - '))
      setValue('box_type', boxNameArray[lastIndex])

      setValue('height_cm', selectedPackage.height_cm)
      setValue('breadth_cm', selectedPackage.breadth_cm)
      setValue('length_cm', selectedPackage.length_cm)

      setValue('status', selectedPackage.status)
    }
  }, [selectedPackage, setValue])

  return (
    <MUIModal
      open={open}
      handleClose={onClose}
      children={<div>Add Package</div>}
      title='Create New Package'
      maxWidth='sm'
    >
      <FormProvider methods={methods} onSubmit={handleSubmit(createPackage)}>
        <Grid container spacing={2} sx={{mt: 1}}>
          <Grid item xs={12}>
            <RHFTextField name='box_name' label='Package Name' fullWidth />
          </Grid>
          <Grid item xs={12}>
            <RHFRadioGroup
              name='box_type'
              label='Package Type'
              options={[
                {label: 'Carton / Box', value: 'Carton'},
                {label: 'Flyer / Envelope', value: 'Flyer'},
              ]}
            />
          </Grid>
          <Grid item xs={4}>
            <RHFTextField name='height_cm' label='Height (cm)' type='number' fullWidth />
          </Grid>
          <Grid item xs={4}>
            <RHFTextField name='breadth_cm' label='Breadth (cm)' type='number' fullWidth />
          </Grid>
          <Grid item xs={4}>
            <RHFTextField name='length_cm' label='Length (cm)' type='number' fullWidth />
          </Grid>
          <Grid item xs={12}>
            <RHFRadioGroup
              name='status'
              label='Status'
              options={[
                {label: 'Active', value: 'ACTIVE'},
                {label: 'Inactive', value: 'INACTIVE'},
              ]}
            />
          </Grid>
          <Grid item xs={12}>
            <RHFFileField name='image' label='Package Image' fullWidth variant='filled' multiple />
          </Grid>
          <Grid item xs={12}>
            <LoadingButton
              type='submit'
              size='medium'
              variant='contained'
              color='primary'
              loading={isCreating}
            >
              {selectedPackage ? 'Update Package' : 'Create Package'}
            </LoadingButton>
          </Grid>
        </Grid>
      </FormProvider>
    </MUIModal>
  )
}
